import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';
import { API_ENDPOINTS } from './api-endpoints';

const override = {
  PERFORM_APP_DYNAMICS: API_ENDPOINTS.PERFORM_APP_DYNAMICS.E2E,
  hostname: API_ENDPOINTS.HOSTNAME.E2E,
  RTI_ENDPOINT: API_ENDPOINTS.RTI_ENDPOINT.E2E,
  RTI_X_API_VALUE: API_ENDPOINTS.RTI_X_API_VALUE.E2E,
  RTI_X_API_KEY: API_ENDPOINTS.RTI_X_API_KEY.COMMON,
  PP_ENDPOINT: API_ENDPOINTS.PP_ENDPOINT.E2E,
  APP_DYNAMIC_KEY: API_ENDPOINTS.APP_DYNAMIC_KEY.E2E,
  DIS_ENDPOINT: API_ENDPOINTS.DIS_ENDPOINT.E2E,
  DIS_X_API_VALUE: API_ENDPOINTS.DIS_X_API_VALUE.E2E,
  DIS_X_API_KEY: API_ENDPOINTS.DIS_X_API_KEY.COMMON,
  CREDIT_APP_ENPOINT:API_ENDPOINTS.CREDIT_APP_ENPOINT.E2E,
  GOOGLE_MAP_API_KEY: API_ENDPOINTS.GOOGLE_MAP_API_KEY.E2E,
  WAF_URL: API_ENDPOINTS.WAF_URL.E2E,
};

export const environment = defaultsDeep(override, environmentDefaults);
